import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {WeaveLoaderComponent} from './weave-loader/weave-loader.component';
import {LoadingService} from '../../services/loading.service';

/**
 * Full-screen loading overlay for the 'global' scope.
 *
 * Mounted once at the app root. Shows the WeaveLoader fixed over the whole
 * viewport whenever LoadingService.isLoading('global') is true — this is what
 * unnamed start()/stop() calls drive.
 */
@Component({
  selector: 'weave-loading-overlay',
  imports: [WeaveLoaderComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (active()) {
      <app-loader class="weave-loading-overlay weave-loading-overlay--fixed"></app-loader>
    }
  `,
})
export class WeaveLoadingOverlayComponent {
  private readonly loading = inject(LoadingService);
  protected readonly active = this.loading.isLoading('global');
}
